export enum NotesEntityNames {
  Vehicle = 'new_fuhrpark',
  Contact = 'contact'
}

export interface UseNotesParams {
  entityName: NotesEntityNames;
  id: string;
}
